import _findNumbers from './findNumbers_';
import { normalizeArguments } from './parsePhoneNumber';
export default function findNumbers() {
  var _normalizeArguments = normalizeArguments(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  return _findNumbers(text, options, metadata);
}